module.exports = __webpack_public_path__ + "static/img/placeholder.d33287b9.png";